import React from "react";
import "./Css/Gallary.css";
import img2 from "./Images/utare.jpg";
import img3 from "./Images/Utare1.jpg";

export default function Utare() {
  return (
    <section className="school-social-section">

      <h2 className="school-social-title">ग्रामपंचायत मध्ये सर्व ऑनलाईन दाखले उतारे सुविधा
      </h2>

      <div className="school-social-grid">

        <img src={img2} alt="event" className="school-img big-img" />

        <div className="right-grid">
          <div className="top-small-row">
            <img src={img2} alt="event" className="school-img small-img" />
            <img src={img3} alt="event" className="school-img small-img" />
          </div>

        </div>
      </div>

    </section>
  );
}
